module.exports = __webpack_public_path__ + "assets/fs-qiyerenzheng.cde978e3.svg";